module.exports = __webpack_public_path__ + "static/media/receivership-order-dated-march-21-2024.a15ee333.pdf";